<div [ngClass]='{"collapse-chat": collapse && !isMobileApp , "mobile-collapse-chat": collapse && isMobileApp, "maximize-chat": maximize, "mobile-collapsed-view": isMobileApp, "dark-theme": isDarkTheme, "web-chat-container": !isMobileApp, "image-preview-open": imagePreviewOpen, "camera-dialog-open": cameraDialogOpen, "ccu-chat-container": isCCU }' class="chat-container"
  (wheel)="onContainerScroll($event)">
  @if (!isMobileApp) {
    <div [ngClass]='{"collapse-header": collapse}' class="chat-header">
      @if (collapse && activeAgentName != null) {
        <span class="header-title">Talk to {{activeAgentName}}</span>
      }
      @if (!collapse) {
        <span class="mobile-header-title">
          @if (chatStatus != 'CHAT_INIT') {
            <app-chat-toggle #chatToggle [disableToggleButton]="disableInput" [chatStatus]="chatStatus" (toggleChat)="onToggleAgentType($event)" [aiAgentName]="aiAgentName" [liveAgentName]="liveAgentName" [chatAgentType]="chatAgentType" [chatScreenConfig]="chatScreenConfig"></app-chat-toggle>
          }
        </span>
      }
      <div class="header-button-container">
        <button class="header-button" (click)="onToggleSpeech()">
          @if (speechEnabled) {
            <i class="fa fa-volume-up"></i>
          }
          @if (!speechEnabled) {
            <i class="fa fa-volume-off"></i>
          }
        </button>
        <button class="header-button" (click)="onClickHelp()">
          <i class="fa fa-question-circle"></i>
        </button>
        @if (!collapse && !maximize) {
          <button class="header-button" (click)="onCollapse()"><i class="fas fa-minus"></i></button>
        }
        @if (collapse) {
          <button class="header-button" (click)="onExpand()">
            <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
              <path fill="currentColor" d="M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"/>
            </svg>
          </button>
        }
        @if (!collapse && !maximize) {
          <button class="header-button" (click)="onMaximize()">
            <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
              <path fill="currentColor" d="M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"/>
            </svg>
          </button>
        }
        @if (maximize) {
          <button class="header-button" (click)="onReset()">
            <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
              <path fill="currentColor" d="M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"/>
            </svg>
          </button>
        }
        <button class="header-button" (click)="onClose()"><i class="fas fa-times"></i></button>
      </div>
    </div>
  }
  @if (isMobileApp) {
    <div [ngClass]='{"mobile-collapse-header": collapse}' class="mobile-chat-header">
      @if (collapse && activeAgentName != null) {
        <span class="header-title">Talk to {{activeAgentName}}</span>
      }
      @if (!collapse) {
        <span class="mobile-header-title">
          @if (chatStatus != 'CHAT_INIT') {
            <app-chat-toggle #chatToggle [disableToggleButton]="disableInput" [chatStatus]="chatStatus" (toggleChat)="onToggleAgentType($event)" [aiAgentName]="aiAgentName" [liveAgentName]="liveAgentName" [chatAgentType]="chatAgentType"  [isMobileApp]="isMobileApp" [isAIChatSubscriptionActive]="isAIChatSubscriptionActive" [chatScreenConfig]="chatScreenConfig"></app-chat-toggle>
          }
        </span>
      }
      <div class="header-button-container" [ngClass]="{'mobile-header-icons-disable': isMobileApp && !isAIChatSubscriptionActive}">
        @if (!collapse && chatScreenConfig?.textToSpeechEnabled) {
          <button class="header-button" (click)="onToggleSpeech()" id="speechToText">
            @if (speechEnabled) {
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path d="M16.34 5.13627C17.9625 6.45377 19 8.46877 19 10.7238C19 12.9788 17.9625 14.9913 16.34 16.3113C16.0825 16.5213 15.705 16.4813 15.495 16.2238C15.285 15.9663 15.325 15.5888 15.5825 15.3788C16.9375 14.2788 17.8 12.6038 17.8 10.7238C17.8 8.84377 16.9375 7.16877 15.5825 6.06627C15.325 5.85627 15.2875 5.47877 15.495 5.22127C15.7025 4.96377 16.0825 4.92627 16.34 5.13377V5.13627ZM14.8275 6.99877C15.9075 7.87877 16.6 9.22127 16.6 10.7238C16.6 12.2263 15.9075 13.5688 14.8275 14.4488C14.57 14.6588 14.1925 14.6188 13.9825 14.3613C13.7725 14.1038 13.8125 13.7263 14.07 13.5163C14.8825 12.8563 15.4 11.8513 15.4 10.7238C15.4 9.59627 14.8825 8.59127 14.07 7.92877C13.8125 7.71877 13.775 7.34127 13.9825 7.08377C14.19 6.82627 14.57 6.78877 14.8275 6.99627V6.99877ZM13.315 8.86127C13.8525 9.30127 14.2 9.97127 14.2 10.7238C14.2 11.4763 13.8525 12.1463 13.315 12.5863C13.0575 12.7963 12.68 12.7563 12.47 12.4988C12.26 12.2413 12.3 11.8638 12.5575 11.6538C12.8275 11.4338 13 11.0988 13 10.7238C13 10.3488 12.8275 10.0138 12.5575 9.79127C12.3 9.58127 12.2625 9.20377 12.47 8.94627C12.6775 8.68877 13.0575 8.65127 13.315 8.85877V8.86127ZM10.5275 5.19377C10.815 5.32377 11 5.60877 11 5.92377V15.5238C11 15.8388 10.815 16.1238 10.5275 16.2538C10.24 16.3838 9.9025 16.3313 9.6675 16.1213L6.295 13.1238H4.6C3.7175 13.1238 3 12.4063 3 11.5238V9.92377C3 9.04127 3.7175 8.32377 4.6 8.32377H6.295L9.6675 5.32627C9.9025 5.11627 10.24 5.06627 10.5275 5.19377Z" fill="currentColor"/>
              </svg>
            }
            @if (!speechEnabled) {
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path d="M14.5275 5.06952C14.815 5.19952 15 5.48452 15 5.79952V15.3995C15 15.7145 14.815 15.9995 14.5275 16.1295C14.24 16.2595 13.9025 16.207 13.6675 15.997L10.295 12.9995H8.6C7.7175 12.9995 7 12.282 7 11.3995V9.79952C7 8.91702 7.7175 8.19952 8.6 8.19952H10.295L13.6675 5.20202C13.9025 4.99202 14.24 4.94202 14.5275 5.06952Z" fill="currentColor"/>
              </svg>
            }
          </button>
        }
        @if (!collapse) {
          <button class="header-button" (click)="onClickHelp()" id="btnHelp">
            <svg class="help-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path d="M14 7C14 10.8669 10.8387 14 7 14C3.13306 14 0 10.8669 0 7C0 3.16129 3.13306 0 7 0C10.8387 0 14 3.16129 14 7ZM7.16936 2.31452C5.64516 2.31452 4.65726 2.96371 3.89516 4.12097C3.78226 4.29032 3.81048 4.4879 3.95161 4.60081L4.93952 5.33468C5.08065 5.44758 5.30645 5.41935 5.41935 5.27823C5.92742 4.62903 6.26613 4.2621 7.02823 4.2621C7.59274 4.2621 8.32661 4.62903 8.32661 5.19355C8.32661 5.61694 7.95968 5.84274 7.39516 6.15323C6.74597 6.52016 5.87097 6.97177 5.87097 8.12903V8.24194C5.87097 8.43952 6.0121 8.58065 6.20968 8.58065H7.79032C7.95968 8.58065 8.12903 8.43952 8.12903 8.24194V8.21371C8.12903 7.42339 10.4718 7.39516 10.4718 5.19355C10.4718 3.55645 8.77823 2.31452 7.16936 2.31452ZM7 9.31452C6.26613 9.31452 5.70161 9.90726 5.70161 10.6129C5.70161 11.3468 6.26613 11.9113 7 11.9113C7.70565 11.9113 8.29839 11.3468 8.29839 10.6129C8.29839 9.90726 7.70565 9.31452 7 9.31452Z" fill="currentColor"/>
            </svg>
          </button>
        }
        @if (!collapse && !maximize) {
          <button class="header-button" (click)="onCollapse()">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path d="M15.8281 9.5H5.67188C5.0249 9.5 4.5 10.0249 4.5 10.6719V11.4531C4.5 12.1001 5.0249 12.625 5.67188 12.625H15.8281C16.4751 12.625 17 12.1001 17 11.4531V10.6719C17 10.0249 16.4751 9.5 15.8281 9.5Z" fill="currentColor"/>
            </svg>
          </button>
        }
        @if (collapse) {
          <button class="header-button" (click)="onExpand()">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path d="M10.6786 12.6071L8.21429 15.0714L9.07143 15.9286C9.5 16.3304 9.20536 17 8.61607 17H5.61607C5.26786 17 5 16.7321 5 16.3571V13.3571C5 12.7946 5.66964 12.5 6.07143 12.9286L6.92857 13.7857L9.39286 11.3214C9.55357 11.1607 9.84821 11.1607 10.0089 11.3214L10.6786 11.9911C10.8393 12.1518 10.8393 12.4464 10.6786 12.6071ZM11.2946 9.41964L13.7857 6.92857L12.9018 6.09821C12.4732 5.69643 12.7679 5 13.3571 5H16.3571C16.7054 5 17 5.29464 17 5.64286V8.64286C17 9.23214 16.3036 9.52679 15.9018 9.09821L15.0714 8.21429L12.5804 10.7054C12.4196 10.8661 12.125 10.8661 11.9643 10.7054L11.2946 10.0357C11.1339 9.875 11.1339 9.58036 11.2946 9.41964Z" fill="currentColor"/>
            </svg>
          </button>
        }
        @if (maximize) {
          <button class="header-button" (click)="onReset()">
            <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
              <path fill="currentColor" d="M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"/>
            </svg>
          </button>
        }
        <button class="header-button" (click)="onClose()" id="btnClose">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M13.2745 11L16.686 7.58852C17.1047 7.16989 17.1047 6.49114 16.686 6.07216L15.9278 5.31398C15.5092 4.89534 14.8305 4.89534 14.4115 5.31398L11 8.72545L7.58852 5.31398C7.16989 4.89534 6.49114 4.89534 6.07216 5.31398L5.31398 6.07216C4.89534 6.4908 4.89534 7.16955 5.31398 7.58852L8.72545 11L5.31398 14.4115C4.89534 14.8301 4.89534 15.5089 5.31398 15.9278L6.07216 16.686C6.4908 17.1047 7.16989 17.1047 7.58852 16.686L11 13.2745L14.4115 16.686C14.8301 17.1047 15.5092 17.1047 15.9278 16.686L16.686 15.9278C17.1047 15.5092 17.1047 14.8305 16.686 14.4115L13.2745 11Z" fill="currentColor"/>
          </svg>
        </button>
      </div>
    </div>
  }
  <div class="chat-messages" [ngClass]='{"mobile-chat-messages": isMobileApp,  "ccu-chat-messages": isCCU, "web-chat-messages-with-preview": !isMobileApp && !isCCU && selectedFile}' #chatContentElement
    (wheel)="onScroll($event)" (touchmove)="onTouchMove($event)">
    @for (message of messages; track message) {
      <div [ngClass]='{"mobile-message-container": isMobileApp && !(message?.data?.supportTicketsContent?.tickets?.length)}' class="chat-message-container">
        @if (message.role == 'user') {
          <div [ngClass]='{"mobile-user-message": isMobileApp}' class="user-message">
            @if (message.data.text) {
              <p [innerHTML]="message.data.text"></p>
            }
            @if (message.data.mediaUrl) {
              <div class="chat-message-image-container">
                <img class="image-preview" [src]="message.data.mediaUrl" alt="User-uploaded image" (click)='openImageInNewTab(message.data.mediaUrl)'>
              </div>
            }
            @if (message.data.file) {
              <div class="file-upload-container">
                <span class="file-upload-label">{{message.data.file.name}}</span>
              </div>
            }
          </div>
        }
        @if (message.role == 'ai' || message.role == 'live_agent') {
          <div class="agent-message" [ngClass]='{"live-agent": message.role == "live_agent", "ai": message.role == "ai", "mobile-agent-message": isMobileApp, "form-message": message.data.formRequest, "active-stream-message": isActiveStreamMessage(message),  "support-tickets-container": $safeNavigationMigration(message?.data?.supportTicketsContent?.tickets?.length), "image-response-container": $safeNavigationMigration(message.data.imageData?.message)}' (mouseover)="onMouseOver(message)" (mouseleave)="onMouseLeave(message)">
            @if (message.data.text) {
              <app-chat-markdown [html]="message.data.text"></app-chat-markdown>
            }
            @if (message.data.imageData?.message) {
              <app-chat-markdown [html]="$safeNavigationMigration(message.data.imageData?.message)"></app-chat-markdown>
            }
            @if (message?.data?.supportTicketsContent?.message?.length && !message?.data?.supportTicketsContent?.tickets?.length) {
              <app-chat-markdown [html]="$safeNavigationMigration(message?.data?.supportTicketsContent?.message)"></app-chat-markdown>
            }
            @if (message.data.mediaUrl) {
              <div class="chat-message-image-container">
                <img class="image-preview" [src]="message.data.mediaUrl" alt="Agent image" (click)='openImageInNewTab(message.data.mediaUrl)'>
              </div>
            }
            @if (message.data.widgetData) {
              <app-chat-widget [isMobileApp]="isMobileApp" [widgetData]="message.data.widgetData"></app-chat-widget>
            }
            @if (message.data.supportData) {
              <app-chat-support-link [supportData]="message.data.supportData"></app-chat-support-link>
            }
            @if (message.data.formRequest) {
              <app-chat-form-input [formRequest]="message.data.formRequest" [isReadOnly]="message !== activeMessage" [isMobileApp]="isMobileApp" [isCCU]="isCCU" (openMobileInAppBrowser)="onMobileCitationLinkClicked($event)"></app-chat-form-input>
            }
            @if ((message?.data?.supportTicketsContent?.tickets?.length ?? 0) > 0) {
              <app-chat-support-tickets [supportTickets]="message?.data?.supportTicketsContent?.tickets ?? []">></app-chat-support-tickets>
            }
            @if (message.data.error) {
              <app-chat-markdown [html]="message.data.error"></app-chat-markdown>
            }
            <!--Subscription Restriction Responses (Portals/Apps)-->
            @if (message.data.subscriptionData) {
              <app-subscription-restriction [isMobileApp]="isMobileApp" [subscriptionData]="message.data.subscriptionData"></app-subscription-restriction>
            }
            <!-- User Feedback -->
            @if (isMobileApp || message._metadata!.showFeedbackPrompt) {
              <app-chat-feedback [isMobileApp]="isMobileApp" [message]="message" (feedbackState)="onFeedbackChange($event)" (close)="closeFeedback(message)" [@fadeInOut] [@.disabled]="isMobileApp"></app-chat-feedback>
            }
          </div>
        }
        <!--Videos & Citation resource cards-->
        @if (message.data.supportData; as supportData) {
          <app-chat-resource-cards [videos]="supportData.videoLinks ?? []"
            [citations]="supportData.citations ?? []" [isMobileApp]="isMobileApp" [isCCU]="isCCU" (mobileCitationLinkClicked)="onMobileCitationLinkClicked($event)">
          </app-chat-resource-cards>
        }
        <!--Image responses-->
        @if (message.data.imageData?.base64Url) {
          <app-chat-image-message [imageData]="message.data.imageData" [isMobileApp]="isMobileApp" [isCCU]="isCCU" (imagePreviewOpen)="imagePreviewOpen = $event"></app-chat-image-message>
        }
        <!-- New Quick select Options (Portal/Apps)-->
        @if (message?.data?.quickSelectOptions) {
          <div id="chat-quick-options" class="quick-options-container">
            <app-quick-select-options [isLoading]="loading" [isMobileApp]="isMobileApp" [isCcuApp]="isCCU" [options]="message.data.quickSelectOptions ?? []" (selected)="onSelectOption($event)"></app-quick-select-options>
          </div>
        }
      </div>
    }

    @if (loading) {
      <div class="loader">
        <div class="typing">
          <span class="circle scaling"></span>
          <span class="circle scaling"></span>
          <span class="circle scaling"></span>
        </div>
      </div>
    }
    @if (liveAgentTypingLoader) {
      <div class="live-agent-typing-loader">
        <div class="typing">
          <span class="circle scaling"></span>
          <span class="circle scaling"></span>
          <span class="circle scaling"></span>
        </div>
      </div>
    }
  </div>
  <div class="chat-footer" [ngClass]='{"mobile-chat-footer": isMobileApp}'>
    @if (micEnabled) {
      <app-chat-audio-level></app-chat-audio-level>
    }
  </div>
  <app-chat-input
    [disableInput]="disableInput"
    [buildingEntityList]="buildingEntityList"
    [loading]="loading"
    [config]="config"
    [isMobileApp]="isMobileApp"
    [isCCU]="isCCU"
    [isAndroid]="isAndroid"
    [chatScreenConfig]="chatScreenConfig"
    [placeholder]="chatInputPlaceholderText"
    [sendIconEnabled]="sendIconEnabled"
    [uploadOptionsEnabled]="uploadOptionsEnabled"
    [showUserInputOptions]="showUserInputOptions"
    (toggleMic)="onToggleMic()"
    (keydown.enter)="onSubmit()"
    (sendMessgae)="onSubmit()"
    (mentions)="onMentions($event)"
    (cameraDialogOpenChange)="onCameraDialogOpenChange($event)"
    [isDarkTheme]="isDarkTheme"
  #chatInput></app-chat-input>
</div>
